module.exports = __webpack_public_path__ + "assets/images/project/netherlands.jpg?v=bfdfe084";